import { Injectable } from '@angular/core';
import { AuthenticateApiService } from './authenticate-api.service';
import { TokenService } from './token.service';

const HEARTBEAT_INTERVAL_MS = 2 * 60 * 1000;

@Injectable({ providedIn: 'root' })
export class PresenceService {
  private intervalId: any = null;

  constructor(
    private authenticateApiService: AuthenticateApiService,
    private tokenService: TokenService,
  ) { }

  start(): void {
    if (this.intervalId) return;

    document.addEventListener('visibilitychange', this.visibilityListener);
    this.sendHeartbeat();
    this.intervalId = setInterval(() => this.sendHeartbeat(), HEARTBEAT_INTERVAL_MS);
  }

  stop(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
    document.removeEventListener('visibilitychange', this.visibilityListener);
  }

  private visibilityListener = (): void => {
    if (document.visibilityState === 'visible') {
      this.sendHeartbeat();
    }
  };

  private sendHeartbeat(): void {
    if (document.visibilityState !== 'visible') return;
    if (!this.tokenService.isAuthenticated()) return;

    this.authenticateApiService.heartbeat().subscribe({ error: () => { } });
  }
}
